import Pqp from "../../3x1010/Pqp";
import Game from "../Game";

export default class EscapeLogic {
	constructor(maze) {
		this.maze = maze;

	}
	init() {
		this.setSpikes();


		/*
		let start = this.maze.getPOIFromType("start")[0];

		let pois = this.maze.getPOIDistanceFrom(start, ["room"]);
		pois.sort(function (a, b) {
			return a.distance - b.distance;
		});
		// Screma i secret room
		let tmp = new Array();
		for (let x = 0; x < pois.length; x++) {
			let other = this.getOtherPOI(pois[x], start);
			let room = other.room;
			if (!room.isHallway()) {
				if (!room.isSecret()) {
					tmp.push(pois[x])
				}
			}
		}*/
		//console.log(tmp);
		/*if (tmp.length > 0) {
			let other = this.getOtherPOI(tmp[0], start);
			let a = other.room.exits;
			for (let x = 0; x < a.length; x++) {
				let exit = a[x];
				exit.lockDoor();
			}
		}*/

	}

	getOtherPOI(o, poi) {
		if (o.poi0.id === poi.id) {
			return o.poi1;
		}
		return o.poi0;
	}

	setSpikes() {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let spikes = this.getHowManySpikes(det.feats)
		//console.log(spikes)

		if (spikes.length > 0) {
			let a = this.maze.solution.slice();
			for (let x = 0; x < 3; x++) {
				a.shift();
			}
			for (let x = 0; x < 3; x++) {
				a.pop();
			}
			let eligibles = new Array();
			for (let x = 0; x < a.length; x++) {
				let cell = a[x];
				// evetualmente li filtra
				if (!cell.isRoom()) {
					if (!cell.isSecretExit()) {
						if (!cell.isRoomExit()) {
							eligibles.push(cell);
						}
					}
				}
			}
			let chosen = this.getDistribuiteCells(spikes, eligibles);
			//console.log(chosen)
			for (let x = 0; x < chosen.length; x++) {
				//console.log(chosen[x])
				//let spikeDet = spikes[x].split(" ")[1];
				let spikeDet = chosen[x].spikeKind;

				chosen[x].spiked = true;
				//chosen[x].spikeKind = spikeDet;
				if (spikeDet === "double") {
					chosen[x].spikeDouble = 0;
					x++;
					if (chosen[x]) {
						chosen[x].booked = true;
						chosen[x].spiked = true;
						chosen[x].spikeKind = "double";
						chosen[x].spikeDouble = 1;
					} else {
						x--;
						chosen[x].booked = true;
						chosen[x].spiked = true;
						chosen[x].spikeKind = "prox";
					}
				}
			}
			this.maze.spikes = chosen;
		}


	}

	getHowManySpikes(feats) {
		/*let a = feats.split(",")
		for (let x = 0; x < a.length; x++) {
			if (a[x].indexOf("spikes") === 0) {
				return parseInt(a[x].split(" ")[1]);
			}
		}
		return 0;*/
		let ret = new Array();
		let a = feats.split(",")
		for (let x = 0; x < a.length; x++) {
			if (jQuery.trim(a[x]).indexOf("spike") === 0) {
				ret.push(jQuery.trim(a[x]));
			}
		}
		return ret;
	}

	getDistribuiteCells(spikes, a) {
		let ret = new Array();
		let spans = Math.floor(a.length / spikes.length);
		let sel = new Array();
		for (let x = 0; x < spikes.length; x++) {
			sel.push(x);
		}
		sel = Pqp.shuffle(sel);
		for (let x = 0; x < sel.length; x++) {
			let index = Pqp.rnd(sel[x] * spans + spans - 1, sel[x] *spans +1);
			//console.log(spans, sel[x] * spans + spans - 1, sel[x] *spans + 1)
			let cell = a[index]
			ret.push(cell);
			let spikeDet = spikes[x].split(" ")[1];
			cell.spikeKind = spikeDet;
			if (spikeDet === "double") {
				if (a[index + 1]) {
					ret.push(a[index + 1]);
				} else {
					ret.push(a[index - 1]);
				}
			}

		}
		let tmp = new Array();
		for (let x = 0; x < ret.length; x++) {
			let lFound = false;
			for (let y = 0; y < tmp.length; y++) {
				if (tmp[y].id === ret[x].id) {
					lFound = true;
					break;
				}
			}
			if (!lFound) {
				tmp.push(ret[x]);
			}
			
		}

		ret = tmp;
		//console.log(ret)

		return ret;
	}


}
